import { useEffect } from 'react';
import './ParticipantsModal.css';

const ParticipantsModal = ({ isOpen, onClose, conversation }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);

  if (!isOpen || !conversation) return null;

  const participants = conversation.users || [];
  const isGroup = conversation.type === 'group';
  const groupName = conversation.context?.name
    || (isGroup ? participants.map(u => u.name).join(', ') : 'Group Chat');

  const getInitials = (name = '') =>
    name
      .split(' ')
      .map((w) => w[0])
      .slice(0, 2)
      .join('')
      .toUpperCase();

  return (
    <div className="tpm-overlay" onClick={onClose}>
      <div className="tpm-container" onClick={(e) => e.stopPropagation()}>
        <div className="tpm-header">
          <div className="tpm-header-left">
            <h2 className="tpm-title">{groupName}</h2>
            <p className="tpm-subtitle">
              {participants.length} participant
              {participants.length !== 1 ? 's' : ''}
            </p>
          </div>
          <button
            className="tpm-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>

        <div className="tpm-body">
          <ul className="tpm-list">
            {participants.map((user) => (
              <li key={user.id} className="tpm-participant">
                {user.avatar ? (
                  <img
                    className="tpm-avatar"
                    src={user.avatar}
                    alt={user.name}
                  />
                ) : (
                  <div className="tpm-avatar-fallback">
                    {getInitials(user.name)}
                  </div>
                )}
                <div className="tpm-info">
                  <span className="tpm-name">{user.name || 'Unknown'}</span>
                  {user.email && (
                    <span className="tpm-email">{user.email}</span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* <div className="tpm-footer">
          <button className="tpm-footer-close-btn" onClick={onClose}>Close</button>
        </div> */}
      </div>
    </div>
  );
};

export default ParticipantsModal;
